import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMinus, faPlus } from "@fortawesome/free-solid-svg-icons";

import { AppContext } from "../../../context";
import { isIpad } from "../../Shared/utils/detect-devices";

const MultipleFlightButton = ({
	index,
	styles,
	numberOfMultipleFlightInput,

	setNumberOfMultipleFlightInput,
}) => {
	const [useAppState] = AppContext.useAppContext();

	const handlePlus = () => {
		if (numberOfMultipleFlightInput >= 2) {
			return;
		}

		if (
			(index === 0 && index + 1 !== numberOfMultipleFlightInput) ||
			index + 1 < numberOfMultipleFlightInput
		) {
			return;
		}

		setNumberOfMultipleFlightInput(numberOfMultipleFlightInput + 1);
	};

	const handleMinus = () => {
		if (index + 1 < numberOfMultipleFlightInput) {
			return;
		}

		if (numberOfMultipleFlightInput >= 1) {
			setNumberOfMultipleFlightInput(numberOfMultipleFlightInput - 1);
		}
	};
	return (
		<div className={styles.multipleFlightButtonWrapper}>
			<button
				type="button"
				className={cx(styles.plus, {
					[styles.noIpadHover]: !isIpad(),
					[styles.plusIncrease]: numberOfMultipleFlightInput > 1,
					[styles.plusDisabled]: numberOfMultipleFlightInput > index + 1 || index + 1 === 2,
					[styles.hideIcon]: useAppState.sovSimplifiedSearchBar && index + 1 < numberOfMultipleFlightInput,
				})}
				onClick={handlePlus}>
				<FontAwesomeIcon icon={faPlus} className={styles?.multipleFlightButton} />
			</button>
			{numberOfMultipleFlightInput > 1 && (
				<button
					type="button"
					className={cx(styles.minus, {
						[styles.noIpadHover]: !isIpad(),
						[styles.hideIcon]: index + 1 < numberOfMultipleFlightInput,
						[styles.plusDisabled]: index + 1 < numberOfMultipleFlightInput,
					})}
					onClick={handleMinus}>
					<FontAwesomeIcon icon={faMinus} className={styles?.multipleFlightButton} />
				</button>
			)}
		</div>
	);
};

MultipleFlightButton.propTypes = {
	index: PropTypes.number,
	numberOfMultipleFlightInput: PropTypes.number,

	styles: PropTypes.shape({
		multipleFlightButtonWrapper: PropTypes.string,
		multipleFlightButton: PropTypes.string,
		plus: PropTypes.string,
		minus: PropTypes.string,
		plusDisabled: PropTypes.string,
		plusIncrease: PropTypes.string,
		plusDecrease: PropTypes.string,
		hideIcon: PropTypes.string,
		noIpadHover: PropTypes.string,
	}),

	setNumberOfMultipleFlightInput: PropTypes.func,
};

MultipleFlightButton.defaultProps = {
	index: undefined,
	numberOfMultipleFlightInput: 1,
	styles: undefined,

	setNumberOfMultipleFlightInput: () => {},
};

export default MultipleFlightButton;
export { MultipleFlightButton };
